import { Routes, Route, Navigate } from "react-router-dom"


import { EventSubscriptionList } from "./EventSubscriptionList";
import { PageLink, PageTitle } from "../../../../../_metronic/layout/core/PageData";
import { useIntl } from "react-intl";
import { EventSubscriptionForm } from "./EventSubscriptionForm";



const EventSubscriptionsRoutes = () => {
  const intl = useIntl();
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  const breadcrumbs_with_lista: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION'}),
      path: '/system-settings/event-subscription',
      isSeparator: false,
      isActive: false,
      disableLink: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
  <Routes>
      <Route index element={
        <>
        <PageTitle breadcrumbs={breadcrumbs}>{intl.formatMessage({id: 'MENU.SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION'})}</PageTitle>
        <EventSubscriptionList />
        </>
        } />
        
      <Route path='add' element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>{intl.formatMessage({id:"SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.ADD"})}</PageTitle>
          <EventSubscriptionForm />
        </>
        } />
      <Route path='edit/:id' element={
        <>
          <PageTitle breadcrumbs={breadcrumbs_with_lista}>{intl.formatMessage({id:"SYSTEM_SETTINGS.EVENTS_SUBSCRIPTION.EDIT"})}</PageTitle>
          <EventSubscriptionForm />
        </>
        } />
        <Route path='*' element={<Navigate to='/error/404' />} />
         
  </Routes>
  )
}

export { EventSubscriptionsRoutes }